import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { GlobalComponent } from 'src/app/global/global.component';
import { ToastrService } from 'ngx-toastr';
import { ClientHttpService } from '../client-parent/client-parent.service';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonApiService } from 'src/app/commonapiservice';
import { CommonHttpService } from 'src/app/common.service';
import { GeneralService } from 'src/app/service/general.service';
import { functionpermission, getHomehealthagency, Homehealthagency } from './home-health-agency.model';
import { HomehealthagencyService } from './home-health-agency.service';
import { HHADataService } from './home-health-agencydataservice';

@Component({
  selector: 'app-home-health-agency',
  templateUrl: './home-health-agency.component.html',
  styleUrls: ['./home-health-agency.component.scss']
})
export class HomeHealthAgencyComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
   @Input() fromClient: string;
    @Output() emithomehealthagency = new EventEmitter<number>()
  HomehealthForm: FormGroup;
  HHAType: string;
  public filterSettings: object;
  Deleteid: any;
  isSaveorUpdateBoolean:boolean=false;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  @ViewChild('grid') public grid: GridComponent;
  public Grid: Observable<DataStateChangeEventArgs>;
  fp: functionpermission = new functionpermission();
  statusList: any = []
  statusListItem: any=[]
  gethomehealthagency : getHomehealthagency = new getHomehealthagency();
  savehomehealthagency : Homehealthagency = new Homehealthagency();
  stateList: any = [];
  
  constructor( public global: GlobalComponent,public toastrService: ToastrService,
    public http: ClientHttpService,private formBuilder: FormBuilder, public homehealthagencyservice : HomehealthagencyService,
  public HHAservice : HHADataService , public commonapi : CommonApiService ,public commonhttp: CommonHttpService ,public general: GeneralService) 
  {
   
    this.HomehealthForm = this.formBuilder.group({
      id: ["00000000-0000-0000-0000-000000000000"],
      hhaName: [' ', Validators.required],
      phoneNumber: ['', [Validators.minLength(14), Validators.maxLength(14)]],
      address: [' ', ],
      city: [' ', ],
      state: [' ', ],
      zipCode: ["",],
      apt: [' ', ],
      email: ["", Validators.email],
      fax: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      statusLid: ["", Validators.required], 
        });
      this.Grid = HHAservice;
   }

  ngOnInit(): void {
    this.filterSettings = {
      type: 'Menu',
    };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.getpermission();
    this.commonhttp
      .getJSON()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        this.stateList = data;
      });
    this.getStatus();
   

  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "HomeHealthAgency");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.http.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data != null) {
          this.fp = data;

        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }

  getHomehealthFilter() {
  
    this.HHAservice.execute(this.gethomehealthagency);
    this.HHAservice.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

    }
     )
  }
   getDetails(saveBos: Homehealthagency) {     
      this.savehomehealthagency = JSON.parse(JSON.stringify(saveBos));
    }

  getStatus() {
    let params = new URLSearchParams();

    params.append("listCode", "STATUS");

    this.http.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.statusListItem = JSON.parse(JSON.stringify(data));
      this.statusListItem.forEach((ele) => {
        ele.Key = ele.id;
        ele.Value = ele.lovName;
      });
      this.statusList = data;
      let values = {
        id: null,
        lovName: "All",
        lovCode: "ALL",
        lovValue: "ALL",
      };
      this.statusList.push(values);
      this.gethomehealthagency.statusLid = this.statusList?.filter(s => s.lovName == "Active")[0].id;
      this.savehomehealthagency.statusLId = this.statusListItem?.filter(s => s.Value == "Active")[0].Key;


      this.getHomehealthFilter();
    })
  }

    //.........................................SaveOrUpdateHHA.............................................
    SaveOrUpdateHHA() {
      this.isSaveorUpdateBoolean=true
      let savefmsitems : Homehealthagency = JSON.parse(JSON.stringify(this.savehomehealthagency))
  
      this.homehealthagencyservice.SaveOrUpdateHHA(savefmsitems).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.isSaveorUpdateBoolean=false
        if (data) {
          if (this.HHAType == 'CreateHHAModal') {
            this.toastrService.success('Home Health Agency saved successfully!');
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
  
          }
          else if (this.HHAType == 'UpdateHHAModal') {
            this.toastrService.success('Home Health Agency updated successfully!');
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
          }
          document.getElementById('openListModal').click();
          this.HomehealthForm.reset();
      
          this.savehomehealthagency = new Homehealthagency();
          this.getHomehealthFilter();
        }
      }, (err: any) => {
        this.isSaveorUpdateBoolean=false
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      })
    }

      CreateorUpdateHHA(data) {
        this.HHAType = data;
        if (this.HHAType == 'CreateHHAModal') {
          this.HomehealthForm.reset();
          this.savehomehealthagency = new Homehealthagency();
          this.HomehealthForm.controls.statusLid.setValue(
            this.statusListItem?.filter((st) => st.Value == "Active")[0].Key
          );
          this.savehomehealthagency.statusLId = this.statusListItem?.filter(s => s.Value == "Active")[0].Key;
          
        }
      }

       setDeleteid(data) {
          this.Deleteid = data;
        }
        //..........................................DeleteLocation...........................................................
        DeleteHHA() {
          let params = new URLSearchParams();
           params.append("Id", this.savehomehealthagency.id.toString());
           let url = "api/HHAgency/DeleteHHAgency?";
           this.commonapi.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
            this.toastrService.success('Home Health Agency deleted successfully!');
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
            this.savehomehealthagency = new Homehealthagency();
            document.getElementById('closeListModal').click();
            this.getHomehealthFilter();
          }, (err: any) => {
            if (err) {
              this.toastrService.error(err, 'Error'), 8000;
            }
          });
      
      
        }

        clearHHA(type: string) {
            this.HHAType = null;
            this.savehomehealthagency = new Homehealthagency();
            this.HomehealthForm.reset();
            if (type == "refresh") {
              this.getHomehealthFilter();
            }
          }


       public onActionHHA(event) {
            this.gethomehealthagency.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
            this.gethomehealthagency.pageitem = this.grid.pagerModule.pagerObj.pageSize;
            if (event.name == "actionBegin" && event.requestType == "filterbeforeopen") {
              this.gethomehealthagency.type = event.columnType
            }
          }

          public dataChangeHHA(L): void {
            let val = (L.action.requestType).toString();
            if (val != "filterchoicerequest") {
              if ((L.sorted || []).length) {
                this.gethomehealthagency.orderColumn = L.sorted[0].name;
                this.gethomehealthagency.orderType = L.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
              }
            }
            if (val == "filtering" && L.action.action != "clearFilter") {
              this.gethomehealthagency.value = L.action.currentFilterObject.value;
              this.gethomehealthagency.field = L.action.currentFilterObject.field;
              this.gethomehealthagency.matchCase = L.action.currentFilterObject.matchCase;
              this.gethomehealthagency.operator = L.action.currentFilterObject.operator;
            }
            else {
              if (val == "filtering" && L.action.action == "clearFilter") {
                this.gethomehealthagency.field = "hhaName";
                this.gethomehealthagency.matchCase = false;
                this.gethomehealthagency.operator = "contains";
                this.gethomehealthagency.value = "";
                this.gethomehealthagency.type = "string";
              }
            }
            this.getHomehealthFilter();
            if (val == "paging" && L.action.name == "actionBegin") {
           
            }
          }

          showLocationColumns() {
            this.grid.columnChooserModule.openColumnChooser(200, 50);
          }
          DemographicPhoneFormat1() {
              this.savehomehealthagency.fax = this.general.converPhoneGoogleLib(this.savehomehealthagency.fax);
        
          }
          DemographicPhoneFormat() {
            this.savehomehealthagency.phoneNumber = this.general.converPhoneGoogleLib(this.savehomehealthagency.phoneNumber);
          }
          keyPress(event: any) {
            const pattern = /[0-9]/;
            let inputChar = String.fromCharCode(event.charCode);
            if (event.keyCode != 8 && !pattern.test(inputChar)) {
              event.preventDefault();
            }
          }
          numberOnly(event): boolean {
            const charCode = (event.which) ? event.which : event.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
              return false;
            }
            return true;
          }

          Refresh() {
             
              this.gethomehealthagency.matchCase = false;
              this.gethomehealthagency.operator = "startswith";
              this.gethomehealthagency.value = "";
              this.gethomehealthagency.type = "string";
              this.gethomehealthagency.field = "hhaName";
              this.gethomehealthagency.statusLid = this.statusList.filter(
                (st) => st.lovName == "Active"
              )[0].id;
              this.gethomehealthagency.currentpageno = 1;
    
              this.getpermission();
              this. getStatus();
            }

        public ngOnDestroy(): void {
          this.onDestroy$.next();
        }
}
